import { type RushFeeConfig } from "@src/appV2/Auth/types";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import { MEDIUM_STALE_TIME } from "src/constants/query";
import { fetchHcfDetails } from "src/containers/facilityDrawer/billing/api";

type FacilityDetails = Partial<{
  userId: string;
  name: string;
  tmz: string;
  phone: string;
  fullAddress?: {
    formatted?: string;
  };
  rates: Record<string, number>;
  requiresLunchBreak: boolean;
  rushFee: RushFeeConfig | null;
}>;

export function useFacilityDetails(
  workplaceId: string,
  details: string[],
  options: { staleTime?: number; enabled?: boolean } = {
    staleTime: MEDIUM_STALE_TIME,
    enabled: true,
  }
) {
  const queryClient = useQueryClient();
  const detailsString = details.join(",");
  const queryKey = ["workplaceUser-details", workplaceId, detailsString];
  const { staleTime } = options;

  const { data, isLoading } = useQuery<FacilityDetails>({
    queryKey,
    queryFn: () => fetchHcfDetails(workplaceId, detailsString),
    staleTime,
    enabled: options.enabled,
  });

  const invalidateCache = () => {
    queryClient.removeQueries(queryKey);
  };

  return {
    data,
    isLoading,
    invalidateCache,
  };
}
